import { render, staticRenderFns } from "./ListarRepartidores.vue?vue&type=template&id=35d079cf&"
import script from "./ListarRepartidores.vue?vue&type=script&lang=js&"
export * from "./ListarRepartidores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports